/// <amd-module name="Build/Admin/Pool/Sources/AgentSource" />
import { IVssPageContext } from "VSS/Platform/Context";

import { TaskAgent } from "DistributedTask/Client/Contracts/TaskAgent";
import { getTaskAgentClient, ITaskAgentRestClient } from "DistributedTask/Client/RestClient/TaskAgent";

export class AgentSource {
    private _client: ITaskAgentRestClient;

    constructor(pageContext: IVssPageContext) {
        this._client = getTaskAgentClient(pageContext);
    }

    public async getAgent(agentId: number, poolId: number): Promise<TaskAgent> {
        return this._client.getAgent(poolId, agentId, true, true, true);
    }

    public async getAgentsForPool(taskAgentPoolId: number): Promise<TaskAgent[]> {
        return this._client.getAgents(taskAgentPoolId, undefined, true, true, true);
    }

    public async updateAgent(agent: TaskAgent, poolId: number): Promise<TaskAgent> {
        return this._client.updateAgent(agent, poolId, agent.id);
    }

    public async deleteAgent(agent: TaskAgent, poolId: number): Promise<void> {
        return this._client.deleteAgent(poolId, agent.id);
    }

    public async refreshAgent(agent: TaskAgent, poolId: number): Promise<void> {
        return this._client.refreshAgent(poolId, agent.id);
    }
}
